module.exports = __webpack_public_path__ + "img/UTFREM-13.3c705112.jpg";